import Vue from "vue";
import axios from "axios";
import debounce from "lodash.debounce";
import moment from "moment";
import * as files from "../../fileUtils";
import { encodeUrlFromRouter, encodeUrlToRouter } from '@/routerUrlEncoding';
import syncReadingsSavedOffline from "./syncReadings";

export default {
  name: "EditReading",
  components: {
    UploadPhoto: require("@/employee/captureMeterReadings/cameraCompWithViewPics/cameraCompWithViewPics.vue").default,
    DxBarChart: require("@/components/charts/dxCharts/dxBarChart.vue").default,
    DxLineChart: require("@/components/charts/dxCharts/dxLineChart.vue").default,
    backButton: require("@/components/backButton/backButton.vue").default,
    SendSmsComp: require("@/components/sendSms/sendSMS.vue").default,
    reportsComp: require("../../common/reports/reports.vue").default,
    editReadingMapComp: require("@/employee/captureMeterReadings/cmrControlPanel/readingsMap/readingsMap.vue").default,
    SearchWindow: require("@/employee/captureMeterReadings/searchModalWindow.vue").default,
    EditReadingBulkMeter: require("@/employee/captureMeterReadings/editReadingBulkMeter/editReadingBulkMeter.vue").default,
    FiltersComp: require("@/employee/captureMeterReadings/filters/filters.vue").default,
    ErrorDialog: require("@/employee/captureMeterReadings/errorDisplayDialog/errorDisplayDialog.vue").default,
    GoSearchComp: require("@/employee/captureMeterReadings/goSearch/goSearch.vue").default,
  },
  props: {
    readingData: {
      type: Object,
    },
  },
  data: function () {
    return {
      initialFieldConStatus: null,
      fieldConStatusDialog: false,
      showHideFilters: false,
      allowLeave: false,
      allowLeaveDialog: false,
      showErrorDialog: false,
      errorsObject: { readings: [], sms: [], photos: [], },

      goSearchEnabled: false,
      showGoSearch: false,
      goSearch: '',

      editDetection: { accessCodeId: 0, mrMsgCodeId: 0, crReading: 0, comment: '', clockOver: false },
      synchronizing: false,
      editBulkMeterReadDialog: false,
      isButtonDisabled: false,
      hideRange: false,
      closeCamDialogAfterSave: false,
      picUploaded: false,
      photos: [],
      activeGraphTab: "barChartTab",
      dxBarChartData: [],
      dxBarChartOptions: [],
      dxLineChartData: [],
      dxLineChartOptions: [],
      xAxisLabel: "",
      yAxisLabel: "",

      yDown: null,
      xDown: null,
      cameFromSearch: false,
      selectedReadingSeq: null,
      showMap: false,
      enablePrintReport: false,
      readingsReady: false,
      bg: "",
      book: "",
      walk: 0,
      seq: 0,
      cycleId: -1,
      readingTitle: "",
      key: 0,

      infoLine1: "",
      //infoLine2: "",
      //infoLine3: "",

      editingReading: null,
      readingHistory: [],

      isPropertyOriented: false,
      errorMarginFlag: false,

      curReadingInputDisabled: false,
      editingOptions: [],
      descrepancyNoAccess: [],
      descrepancyMrNote: [],
      meterMake: [],
      meterSize: [],
      consumerType: [],
      isCapturePhotoMandatory: false,

      bSpotBillEnabled: false,
      bHasPhone: false,
      bIsFieldWorker: true,

      reports: [],
      reportId: -1,

      searchEnabled: false,
      disableNavigateRight: false,
      disableNavigateLeft: true,

      iValueEditIndex: -1,
      iValueEditIndexSaved: -1,

      readings: [],
      filteredReadings: [],
      readingsSearchResults: [],
      searchObj: {
        ConsumerTypeId: "",
        TenantName: "",
        Address: "",
        PropRef: "",
        SerialNo: "",
      },
      searchDialog: false,
      loadSearchList: false,
      loadSearchListIsDisabled: false,
      readingActionsDialog: false,
      showSendSmsDialog: false,
      geoLocation: null,
      hasReadingUpdated: false,

      alertWarningDialog: false,
      alertWarningDialogTitle: "",
      alertWarningDialogContent: "",
      alertErrorDialog: false,
      alertErrorDialogContent: "",

      prevReadingsTableVisibility: false,
      readingsHistory: [],
      editingHistory: [],

      bShowCamera: false,
      bShowGraph: false,
      cameraResolution: { width: 500, height: 375 },
      //readUnread states: 0 - off, 1 - unread, 2 -read
      advancedSearchResults: [],
      advancedSearchDialog: false,
      offlineSearchType: "meterNo",
      offlineSearchText: "",
      nonEditedReading: { crReading: '', accessCodeId: '', mrMsgCodeId: '', clockOver: false, isSaved: false },
      onlineTimerCheck: null,
      navigatorConnection: { effectiveType: null, downlink: null },
      offLineTimer: 0,
      numSecsToWaitUntillOnline: 10000, //ms
      onLine: navigator.onLine,
      editBulkMeterDataObj: null,
      isBusy: false,
      fetchingBulkMeterDialog: false,
      filtersDataObj: {
        trim: { readUnread: "0", withNote: false, withAccess: false, disconnected: true, discrepancy: false },
        readings: [],
        spotBillEnabled: false,
        filteredReadings: [],
        showDialog: false,
        saveFilters: this.saveFilters
      },
    };
  },
  computed: {
    getOfflineClass: function () {
      return this.onLine ? 'transparent-strip' : 'red-strip';
    },
    showReadingsActions: function () {
      return (
        (this.editingReading.statementNo &&
          this.editingReading.statementNo.length > 0 &&
          this.bSpotBillEnabled === true) ||
        this.highConsumptionFlag != true ||
        (this.highConsumptionFlag == true &&
          this.hasReadingUpdated == true &&
          this.editingReading.cellTelNo != null &&
          this.editingReading.cellTelNo != "") ||
        ((!this.editingReading.statementNo ||
          this.editingReading.statementNo.length === 0) &&
          this.bSpotBillEnabled === true) ||
        (this.editingReading.cellTelNo != null &&
          this.editingReading.cellTelNo != "") ||
        (this.editingReading.cellTelNo != null &&
          this.editingReading.cellTelNo != "" &&
          this.editingReading.statementNo != null &&
          this.editingReading.statementNo.length > 0)
      );
    },
    accessCode: function () {
      return this.accessIdToDescription(this.editingReading.accessCodeId);
    },
    accountOrPropRef: function () {
      return this.isPropertyOriented == true ? this.editingReading.propRef : this.editingReading.account;

      //return this.isPropertyOriented == true
      //  ? this.$t("captureMR.propertyRef") + ": " + this.editingReading.propRef
      //  : this.$t("enquiries.accountNo") + ": " + this.editingReading.account;
    },
    positionInArray: function () {
      return this.iValueEditIndex + 1;
    },
    highConsumptionFlag: function () {
      if (this.editingReading.bMsgMax || this.editingReading.bMsgMin || this.editingReading.bMsgNegative)
        return true;
      else return false;
    },
    expectedRange: function () {
      return this.expectedRangeFunc(this.editingReading);
    },
    getClockOverButtonClass: function () {
      if (this.editingReading.clockOver === true)
        return 'md-primary';
      else
        return ' ';
    },
    infoLine2: function () {
      if (this.editingOptions.customerMeterReadingUseQuarterType) {
        const line = `${this.$t('captureMR.ColumnPrevRdg')}: ${this.editingReading.previousReadings[0] ?? 0} - ${this.$t('captureMR.ColumnPrevCons')}: ${this.editingReading.previousConsumptions[0] ?? 0} / ${this.editingReading.previousConsumptions[1] ?? 0} / ${this.editingReading.previousConsumptions[2] ?? 0} / ${this.editingReading.previousConsumptions[3] ?? 0}`;
        if (line.length > 200)
          return '';
        else
          return line;
      }
      else
        return null;
    },
    infoLine3: function () {
      return null;
    },
    showCameraButton: function () {
      if (this.isCapturePhotoMandatory != true)
        return false;

      if ((this.editingReading.crReading != null && this.editingReading.crReading != '') || this.picUploaded == true)
        return false;
      else
        return true;
    },
    readingsLength: function () {
      return this.readings ? this.readings.length : 0;
    },
    filteredReadingsLength: function () {
      return this.filtersDataObj && this.filtersDataObj.filteredReadings ? this.filtersDataObj.filteredReadings.length : 0;
    },
    disableFilters: function () {
      return this.goSearchEnabled == true || (this.searchEnabled == true && !this.cameFromSearch);
    },
    disconnectedMeter: function () {
      return (this.editingReading.connectionStatus == 0 || this.editingReading.connectionStatus == 3) && !this.editingReading.meterRef;
    },
    isSaveButtDisabled: function () {
      if ((this.initialFieldConStatus != this.editingReading.fieldStatus) || (this.disconnectedMeter && !(this.editingReading.statementNo != null && this.editingReading.statementNo != '' && this.showCameraButton)))
        return false;
      else
        return (this.editingReading.statementNo != null && this.editingReading.statementNo != '' && this.showCameraButton) ||
          this.isButtonDisabled ||
          ((this.editingReading.crReading == null || this.editingReading.crReading == '') && this.editingReading.accessCodeId == 0) ||
          this.editingReading.isReadOnly;
    },
    saveButtonClass: function () {
      if (this.isSaveButtDisabled)
        return 'background-color-disabled';
      else
        return this.editingReading.isEdited ? 'background-red' : 'md-primary'
    },
    saveButtonIconClass: function () {
      return this.isSaveButtDisabled ? 'color-disabled' : 'color-white';
    },
    trimmedDescrepancyMrNote: function () {
      if (this.editingReading.accessCodeId > 0) {
        let descrList = this.descrepancyMrNote.filter(d => d.estimateConsumption != true && d.meterReplaced != true && d.id > 0);

        if (this.editingReading.mrMsgCodeId && descrList.filter(d => this.editingReading.mrMsgCodeId == d.id).length == 0) {
          //user hase note not compatible
          this.editingReading.mrMsgCodeId = '';
          this.editingReading["mrMsg"] = '';
          this.$oldAlertMsg(this.$t('captureMR.NoteReseted'), 3);
        }
        return descrList;
      }
      else
        return this.descrepancyMrNote;
    },
    backButtonUrl() {
      return this.bg && this.book && this.walk ? `captureMeterReadings2/${this.bg}/${this.book}/${this.walk}/` : null;
    },
    fieldConStatus: {
      get: function () {
        return this.editingReading && this.editingReading.fieldStatus ? this.editingReading.fieldStatus.toString() : '0';
      },
      set: function (val) {
        if (this.editingReading)
          this.editingReading.fieldStatus = parseInt(val);
        //console.log("djkjdd", this.editingReading.fieldStatus)
      }
    },
  },
  watch: {
    disableFilters: function (value) {
      if (value)
        this.filtersDataObj.showDialog = false;
    },
    readingsLength: function (value) {
      this.filtersDataObj['readings'] = value > 0 ? this.readings : [];
    },
    filteredReadingsLength: function (value) {
      if (!value)
        return;

      this.filterReadings(this.filtersDataObj.filteredReadings);
    },
    onLine: function (value) {
      if (value) {
        this.$oldAlertMsg(this.$t("messages.online"), 1);
        this.saveOfflineReadings();
      }
      else {
        this.$oldAlertMsg(this.$t("messages.offline"), 1);
        this.showMap = false;
      }

    },
    "editingReading.meterRef": function (value) {
      if (!value)
        return;

      this.$store.commit('setEditReadingActiveRecord', this.editingReading);
    },
    "editingReading.accessCodeId": function (value) {
      this.editDetectionFunc({ accessCodeId: value });

      this.editingReading["access"] = this.accessCodeIdToDescription(value);

      if (value == 0) this.curReadingInputDisabled = false;
      else {
        this.curReadingInputDisabled = true;
        this.editingReading.crReading = "";
      }

      this.editingReading['disabled'] = this.curReadingInputDisabled;
    },
    "editingReading.mrMsgCodeId": function (value) {
      let msgCode = this.trimmedDescrepancyMrNote.filter(t => t.id == value);
      if (!msgCode[0].forceZeroConsumption)
        this.editingReading.crReading = 0;

      this.editDetectionFunc({ mrMsgCodeId: value });

      this.editingReading["mrMsg"] = this.msgCodeIdToDescription(value);
    },
    "editingReading.comment": function (value) {
      this.editDetectionFunc({ comment: value });
    },
    "editingReading.crReading": function (value) {
      this.editDetectionFunc({ crReading: value });

      this.debouncedCrReading(this.editingReading);
      this.calculateConsumption(this.editingReading);
    },
    "editingReading.clockOver": function (value) {
      this.editDetectionFunc({ clockOver: value });

      this.debouncedCrReading(this.editingReading);
      this.calculateConsumption(this.editingReading);
    },
    prevReadingsTableVisibility: function (value) {
      if (value == null || value == "")
        this.writePrevReadingsTableVisibility(false);
      else this.writePrevReadingsTableVisibility(value);
    },
    iValueEditIndex: function (value) {
      if (value)
        this.flashBackground();
    },
    showGoSearch: function (value) {
      if (value == true)
        this.showMap = false;
    },
    advancedSearchDialog: function (value) {
      if (!value)
        this.$setFocusToElement('currReading', true, 500);
    }
  },
  beforeUnmount() {
    this.debouncedCrReading.cancel();
    this.debouncedCamera.cancel();

    let gui = document.getElementById("main_gui_for_reading");
    //gui.removeEventListener("touchmove", this.handleMove);
    //gui.removeEventListener("touchstart", this.touchStart);
  },
  created() {
    if (this.$store.state.userProfile.portalCaptureMeterReadings != true)
      this.$router.push('/employeeHome');

    this.activeGraphTab = this.$localStorage.get("_captureMeterReadingsGraphTabLocation");
    this.init();
  },
  mounted() {
    this.onLineTimerCheck = setInterval(() => {
      this.navigatorConnection = {
        downlink: navigator['connection']['downlink'],
        effectiveType: navigator['connection']['effectiveType']
      };
      this.isConsideredOnline();
    }, 1000);

    this.$root.$on('profile_details_updated', () => this.bSpotBillEnabled = this.$store.state.settings.spotBilling);
    this.bSpotBillEnabled = this.$store.state.settings.spotBilling;
    this.filtersDataObj['spotBillEnabled'] = this.bSpotBillEnabled ?? false;

    setTimeout(() => {
      if (this.editingReading == null || this.editingReading.cycleId == null || this.editingReading.cycleId == '' || this.editingReading.cycleId < 0) {
        this.$alertMsg(this.$t('captureMR.CycleIdError'));
        this.$router.push('/captureMeterReadingsBgBooks/' + this.$route.params.bg);
        return;
      }

      this.editingReading.isEdited = false;
    }, 2000);

    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    window.addEventListener('beforeunload', this.beforeunload);

    let gui = document.getElementById("main_gui_for_reading");
    //gui.addEventListener("touchmove", this.touchMove, false);
    //gui.addEventListener("touchstart", this.touchStart, false);

    this.showHideFilters = this.$localStorage.get('_cmrShowTrimFilters') == 'true';
  },
  beforeRouteLeave(to, from, next) {
    if (this.allowLeave)
      next();

    if (!this.checkForEditedReadings(false))
      next();
    else
      this.allowLeaveDialog = true;

  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
    window.removeEventListener('beforeunload', this.beforeunload);

    if (this.onLineTimerCheck != null)
      clearTimeout(this.onLineTimerCheck);
  },
  methods: {
    //==========Con Status=================
    getFieldConStatusButtonClass() {
      return this.fieldConStatus == 0 || this.fieldConStatus == 1 ? ' background-green' : ' background-red';
    },
    getFieldConStatusIconClass() {
      let clss = 'display-flex';
      clss = clss + ' fa fa-tachometer color-white';

      return clss;
    },
    getFieldConStatusIcon(item) {
      switch (item) {
        default:
          return require('@/assets/images/meterReadings/meter-off-green.svg');
        case 1:
          return require('@/assets/images/meterReadings/meter-on-green.svg');
        case 2:
          return require('@/assets/images/meterReadings/meter-on-red.svg');
        case 3:
          return require('@/assets/images/meterReadings/meter-off-red.svg');
      }
    },
    fieldConStatusButtonClicked() {
      this.fieldConStatusDialog = !this.fieldConStatusDialog;
    },
    fieldConStatusSelected() {
      if (this.initialFieldConStatus != this.editingReading.fieldStatus)
        this.editingReading.isEdited = true;

      setTimeout(() => this.fieldConStatusDialog = false, 500);
    },
    //====================================

    noteSelected(item) { },
    showHideFiltersFunc() {
      this.showHideFilters = !this.showHideFilters;
      this.$localStorage.set('_cmrShowTrimFilters', this.showHideFilters);
    },
    saveFilters(trim) {
      this.filtersDataObj.trim = { ...trim };
    },
    leaveDiaologActions(isleaving = false) {
      if (isleaving) {
        this.allowLeave = true;
        this.$router.push(`/captureMeterReadings2/${encodeURIComponent(this.bg)}/${encodeURIComponent(this.book)}/${encodeURIComponent(this.walk)}`);
      }

      this.allowLeaveDialog = false
    },
    editDetectionFunc(item) {
      if (item.clockOver != null && item.clockOver != this.editDetection.clockOver ||
        item.crReading != null && item.crReading != this.editDetection.crReading ||
        item.comment != null && item.comment != this.editDetection.comment ||
        item.mrMsgCodeId != null && item.mrMsgCodeId != this.editDetection.mrMsgCodeId ||
        item.accessCodeId != null && item.accessCodeId != this.editDetection.accessCodeId) {
        this.editingReading.isEdited = true;
      }

      if (this.editingReading.clockOver == this.editDetection.clockOver &&
        this.editingReading.crReading == this.editDetection.crReading &&
        this.editingReading.comment == this.editDetection.comment &&
        this.editingReading.mrMsgCodeId == this.editDetection.mrMsgCodeId &&
        this.editingReading.accessCodeId == this.editDetection.accessCodeId) {
        this.editingReading.isEdited = false;
      }
    },
    expectedRangeFunc(read) {
      if (this.hideRange || this.editingOptions.customerMeterReadingUseQuarterType != true ||
        read.consumption == null || read.consumption == '' || read.consumption <= 0 ||
        (read.connType == 2 && read.bulkAverageConsumptionDiffMin <= 0 && read.bulkAverageConsumptionDiffMax <= 0)) {
        return "";
      }

      if (read.connType == 2 && read.bulkAverageConsumptionDiffMin != null && read.bulkAverageConsumptionDiffMax != null) {

        if (this.editingOptions.billingHhuBulkConsumptionDiffWarningValue > 0 &&
          this.read.differenceWithSubmeters != null && this.read.differenceWithSubmeters > 0 &&
          this.editingOptions.billingHhuBulkConsumptionDiffWarningValue < this.read.differenceWithSubmeters) {
          return (", " + this.$t("captureMR.ExpectedRange") + " " + read.bulkAverageConsumptionDiffMin + "-" + read.bulkAverageConsumptionDiffMax);
        }
      }

      if (read.similarPeriodConsumptionMin != null && read.similarPeriodConsumptionMax != null)
        return (", " + this.$t("captureMR.ExpectedRange") + " " + read.similarPeriodConsumptionMin + "-" + read.similarPeriodConsumptionMax);

      return "";
    },
    openBulkMeterDialog(close = true) {
      if (close == false) {
        this.editBulkMeterDataObj = null;
        this.editBulkMeterReadDialog = false;
        return;
      }

      this.fetchingBulkMeterDialog = true;

      let bulkMeter, meter;

      //check if bulk/sub meter
      if (this.editingReading.connType != 2) { //non bulk
        this.fetchingBulkMeterDialog = false;
        return;
        //let bulkConId = this.editingReading.bulkConnectionId;
        //if (bulkConId == null || bulkConId == 0)
        //  return;
        //else {
        //  meter = this.readings.filter(r => r.connectionId == bulkConId);
        //  if (meter == null && meter.length == 0)
        //    return;

        //  bulkMeter = meter[0];
        //}
      }
      else { //bulk meter
        bulkMeter = this.editingReading;
      }

      let subMeters = this.readings.filter(r => r.bulkConnectionId == bulkMeter.connectionId);

      if (bulkMeter == null || subMeters == null) {
        this.fetchingBulkMeterDialog = false;
        return;
      }

      subMeters.forEach(s => { this.prepareSubMeterReadings(s) });

      this.editBulkMeterDataObj = {
        bulkMeter,
        subMeters,
        getInputClass: this.getInputClass,
        showHelp: this.showHelp,
        setConsumption: this.setConsumption,
        //save: this.saveBatchMeters,
        hideRange: this.hideRange,
        editingOptions: this.editingOptions,
      };


      this.editBulkMeterReadDialog = true;
      this.fetchingBulkMeterDialog = false;
    },
    prepareSubMeterReadings(read) {
      read.crDate = new Date();
      read.bMsgInvalid = false;
      read.bMsgNegative = false;
      read.bMsgMax = false;
      read.bMsgMin = false;

      read["access"] = this.accessCodeIdToDescription(read.accessCodeId);
      read["mrMsg"] = this.msgCodeIdToDescription(read.mrMsgCodeId);

      //this.setConsumption(read);


      if (read.accessCodeId == 0)
        read['disabled'] = false;
      else {
        read['disabled'] = true;
        read.crReading = "";
      }
    },
    async saveBatchMeters(data, haveGeolocation) {
      let items = [];
      let dbItems = await this.$store.getters.getCmrBulkMeter;

      dbItems.subMeters.forEach(s => items.push(s));
      items.push(dbItems.bulkMeter);


      if (items.length == 0)
        return;

      //checks
      if (this.editingOptions.customerMeterReadingUseQuarterType == true) {
        //find sub meters
        let reads = dbItems.subMeters;
        let flag = this.submetersHaveValue(reads);

        if (flag == false) {
          this.$alertMsg(this.$t("captureMR.SubconnectionsNotRead"), 3);
        }
        else {
          await this.checkDifOfBulkAndSubmeters(this.editingReading);
        }
      }

      let flag = false;
      items.forEach(async reading => {
        if (moment(reading.crDate).isAfter(new Date())) {
          this.$alertMsg(`(# ${reading.meterRef}) ${this.$t("captureMR.currDateError")}`, 4);
          await new Promise((resolve) => setTimeout(resolve, 2000));
        }

        //add geolocation
        if (this.geoLocation != null) {
          reading.CoordLat = this.geoLocation.latitude;
          reading.CoordLong = this.geoLocation.longitude;
          reading.CoordAccuracy = this.geoLocation.accuracy;
        }
      });

      if (!haveGeolocation)
        this.$oldAlertMsg(this.$t("messages.noGeolocationCaptured"), 3);

      if (flag)
        return;

      //start saving
      this.isBusy = true;
      let readsArray = await this.saveReadingLocally(null, items);

      let indx;
      //if (this.onLine) {
      if (this.onLine) {
        axios.post("/CaptureMeterReading/UpdateReadingdDetailsForBulkMeter", items)
          .then((resp) => {
            if (resp.status != 200) {
              this.$alertMsg('Error Saving Batch and Sub Meters');
              return;
            }

            items.forEach(i => {
              if (i.bMsgMax || i.bMsgMin || i.bMsgNegative) {
                this.showSmsWindowChoices = true;
                this.updateReadingAlert(resp.data.items.filter(r => r.item.meterRef == i.meterRef), i);
              }
            });

            this.issueAfterUpdate = false;

            resp.data.items.forEach(r => {
              indx = this.readings.findIndex(q => q.meterRef == r.item.meterRef);
              if (indx >= 0)
                this.readings[indx] = r.item;

              if (r.item.meterRef == this.editingReading.meterRef) {
                this.editingReading = r.item;
                this.hasReadingUpdated = true;
              }
            });

            this.hasReadingUpdated = true;

            this.$oldAlertMsg(this.$t("messages.ReadingUpdatedSuccess"), 2);
            this.issueAfterUpdate = false;
            this.openBulkMeterDialog(this.editBulkMeterReadDialog);
          })
          .catch(err => this.$alertMsg(err))
          .finally(() => { this.isBusy = false });
      }
      else {
        this.$store.state.readingsLocalDB
          .get(`readingsSavedOffline`)
          .then((doc) => {
            readsArray.forEach(reading => {
              const searchReads = doc.readings.filter((a) => a.bookId == this.book && a.walkId == this.walk && a.seq == reading.sequence);

              if (searchReads.length == 0) {
                doc.readings.push({
                  bookId: this.book,
                  walkId: this.walk,
                  seq: reading.sequence,
                  reading: reading,
                  isSync: false,
                });
              } else {
                searchReads[0].reading = reading;
              }
            });

            this.$oldAlertMsg(this.$t("messages.ReadingUpdatedSuccess"), 2);
          })
          .catch((err) => {
            if (err.status == 404) {
              let arr = [];

              readsArray.forEach(reading => {
                arr.push({
                  bookId: this.book,
                  walkId: this.walk,
                  seq: reading.sequence,
                  reading: reading,
                  isSync: false,
                })
              });

              this.$store.state.readingsLocalDB.put({
                _id: `readingsSavedOffline`,
                readings: arr,
              });

              this.$oldAlertMsg(this.$t("messages.ReadingUpdatedSuccess"), 2);
            }
          })
          .finally(() => {
            this.isBusy = false;
            this.openBulkMeterDialog(this.editBulkMeterReadDialog);
          });
      }
    },
    isConsideredOnline(isOffline = false) {
      let navOnline = navigator.onLine;

      this.onLine = !isOffline && navOnline && (this.navigatorConnection.effectiveType === '3g' || this.navigatorConnection.effectiveType === '4g');
      this.$store.commit("setCsAppsOfflineMode", { status: !this.onLine });

      //console.log("#", this.onLineCounter, " -- navigator.onLine", navOnline, "(", this.navigatorConnection.effectiveType, ") - onLine", this.onLine);
    },
    async saveOfflineReadings() {
      if (this.onLine) {
        this.synchronizing = true;

        await syncReadingsSavedOffline(this.$store.state.readingsLocalDB, this.editingReading);

        //check if all synced or errors
        await this.getDataSavedOffline()
          .then(resp => {
            this.errorsObject = {
              readings: resp.readings.filter(a => a.isSync == false),
              sms: resp.photos.filter(a => a.isSync == false),
              photos: resp.sms.filter(a => a.isSync == false),
            }

            if (this.errorsObject.readings.length > 0 || this.errorsObject.sms.length > 0 || this.errorsObject.photos.length > 0)
              this.showErrorDialog = true;
          });

        this.synchronizing = false;
      }
      return false;
    },
    async getDataSavedOffline(type = null) {
      let retObj = { readings: [], sms: [], photos: [], };

      if (type == 'readings') {
        await this.$store.state.readingsLocalDB.get(`readingsSavedOffline`)
          .then(async doc => {
            retObj.readings = [...doc.readings];
          })
          .catch(err => { });
      }
      else if (type == 'sms') {
        await this.$store.state.readingsLocalDB.get(`readingsSmsRequestsSavedOffline`)
          .then(async doc => {
            retObj.sms = [...doc.requests];
          })
          .catch(err => { });
      }
      else if (type == 'photos') {
        await this.$store.state.readingsLocalDB.get(`readingsPhotosSavedOffline`)
          .then(async doc => {
            retObj.photos = [...doc.photos];
          })
          .catch(err => { });
      }
      else {
        await this.$store.state.readingsLocalDB.get(`readingsSavedOffline`)
          .then(async doc => {
            retObj.readings = [...doc.readings];
          })
          .catch(err => { });

        await this.$store.state.readingsLocalDB.get(`readingsPhotosSavedOffline`)
          .then(async doc => {
            retObj.photos = [...doc.photos];
          })
          .catch(err => { });

        await this.$store.state.readingsLocalDB.get(`readingsSmsRequestsSavedOffline`)
          .then(async doc => {
            retObj.sms = [...doc.requests];
          })
          .catch(err => { });
      }

      return retObj;
    },

    beforeunload(event) {
      if (!this.onLine) {
        event.preventDefault();
        event.returnValue = ""
      }
    },
    clockOverButtonClicked() {
      this.editingReading.clockOver = this.editingReading.clockOver == true ? false : true;
    },
    setEditingReading(item) {
      this.editDetection = {
        accessCodeId: item.accessCodeId ? item.accessCodeId : 0,
        mrMsgCodeId: item.mrMsgCodeId ? item.mrMsgCodeId : 0,
        crReading: item.crReading ? item.crReading : '',
        comment: item.comment ? item.comment : '',
        clockOver: item.clockOver == true
      }

      this.editingReading = item;

      let msgCode = this.trimmedDescrepancyMrNote.filter(t => t.id == this.editingReading.mrMsgCodeId);
      if (msgCode[0].forceZeroConsumption)
        this.editingReading.crReading = 0;

      this.$root.$emit('redraw_map');
    },

    isDisconnectedDiscrepancyColor(item) {
      if (item.connectionStatus == 2 || item.connectionStatus == 3)
        return "color: red !important;";
      else if (
        item.readingDiscrepancyType >= 3 &&
        item.readingDiscrepancyType <= 17
      )
        return "color: #FF8C00!important;";
      else return "";
    },
    graphTabChanged(value) {
      this.activeGraphTab = value;
      this.$localStorage.set("_captureMeterReadingsGraphTabLocation", value);
    },
    async init() {
      this.$root.$on("selected_reading_changed", (seq) => this.selectedReadingChanged(seq));

      this.isConsideredOnline();

      if (window.location.pathname.slice(1, 31) == "captureMeterReadingEditReading")
        this.cameFromSearch = true;

      if (this.readingData) {
        this.bg = encodeUrlFromRouter(this.readingData.bg);
        this.book = encodeUrlFromRouter(this.readingData.book);
        this.walk = encodeUrlFromRouter(this.readingData.walk);
        this.seq = encodeUrlFromRouter(this.readingData.seq);
        this.getBillingGroupName();
      } else {
        this.bg = encodeUrlFromRouter(this.$route.params.bg);
        this.book = encodeUrlFromRouter(this.$route.params.book);
        this.walk = encodeUrlFromRouter(this.$route.params.walk);
        this.getBillingGroupName();

        if (this.$route.params.seq) this.seq = this.$route.params.seq;
        else this.seq = -1;
      }

      this.debouncedCrReading = debounce(() => {
        this.setConsumption(this.editingReading);
      }, 2000);

      this.debouncedCamera = debounce(() => {
        this.onStart();
      }, 2000);

      this.getCommonData();
      this.fillDataFromProfile();
      this.getReadingData();
      this.getCycleId();

      this.isPropertyOriented = await this.getSettings();
    },
    selectedReadingChanged(numb) {
      //this.setEditingReading(this.readings.filter((r) => r.sequence == seq)[0]);
      this.navigateMobile('go_to_reading', numb)
      //this.getPhotos();
      this.$forceUpdate();
    },
    scrollToElement(elem, param = null) {
      if (!elem)
        return;

      if (param == null)
        param = { behavior: "smooth", block: "start", inline: "center", };

      let element = document.getElementById(elem);

      if (element)
        element.scrollIntoView(param);
    },
    getSettings() {
      if (this.$store.state.settings.isPropertyOriented != null) {
        return this.$store.state.settings.isPropertyOriented;
      } else {
        return axios
          .post("/Utility/GetSettings")
          .then((response) => {
            if (response.data.data.status == 0) {
              this.$store.commit("setSettings", { data: response.data.value });
              return response.data.value.isPropertyOriented;
            }
          })
          .catch(() => {
            this.$showMsg("Error Getting Settings");
            //this.$router.push("/login");
          });
      }
    },
    getBillingGroupName() {
      this.$store.state.readingsLocalDB
        .get(`billingGroups`)
        .then((doc) => {
          this.readingTitle = doc.billingGroups.filter((a) => a.id == this.bg)[0].name;
          this.getBookWalkName();
        })
        .catch((err) => { });
    },
    getBookWalkName() {
      this.$store.state.readingsLocalDB
        .get(`bg_${this.bg}_booksWalks`)
        .then((doc) => {
          this.readingTitle += " / " + doc.booksWalks.filter((a) => a.bookId == this.book && a.walkId == this.walk)[0].name;
          this.key = this.key + 1;
        })
        .catch((err) => { });
    },
    updateOnlineStatus(e) {
      const { type } = e;

      this.isConsideredOnline(type != 'online');

    },
    getReadingData() {
      //console.log(this.book, this.walk);
      this.$store.state.readingsLocalDB
        .get(`${this.book}_${this.walk}`)
        .then((doc) => {
          this.readings = doc.readings;
          //this.filteredReadings = doc.readings;
          this.readingsHistory = doc.readingsHistory;
          this.filterReadings(this.readings);
          //this.prepareReadingsList();
        })
        .catch((err) => {
          console.log(err);
          this.$alertMsg("No data found for selected reading!");
        });
    },
    getCycleId() {
      this.$store.state.readingsLocalDB
        .get(`billingGroups`)
        .then((doc) => {
          this.cycleId = doc.billingGroups.filter((a) => a.id == this.bg)[0].cycleId;
        })
        .catch((err) => {
          this.$alertMsg("No data found for billing group");
        });
    },

    //@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
    //Low High Limits
    //@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
    getInputClass(value) {
      //console.log("getInputClass val", value)
      var sClass = "";
      value.bMsgMin = false;
      value.bMsgMax = false;
      value.bZeroConsumption = false;
      value.bMsgNegative = false;
      value.bMsgInvalid = false;
      value.bMsgNegativeConsumption = false;
      value['expectedRange'] = '';

      //console.log("value", value);
      //console.log("value.consumption", value.consumption);
      //console.log("this.editingReading.prRead1", this.editingReading.prRead1);


      if (value.crReading < 0) {
        sClass = "md-invalid";
        value.bMsgInvalid = true;
        this.errorMarginFlag = true;
        return value.disabled || value.isReadOnly ? '' : 'sClass';
      }

      if (!value.crReading) {
        sClass = "md-invalid";
        value.bMsgInvalid = true;
        this.errorMarginFlag = true;
        this.hideRange = false;
        return value.disabled || value.isReadOnly ? '' : 'sClass';
      }

      if (this.editingReading.specialCase)
        return;

      if (value.consumption < 0) {
        sClass = "md-invalid";
        value.bMsgNegativeConsumption = true;
        this.errorMarginFlag = true;
        this.hideRange = false;
        return value.disabled || value.isReadOnly ? '' : 'sClass';
      }

      if (value.crReading > Math.pow(10, value.noDials) - 1) {
        sClass = "md-invalid";
        value.bMsgInvalid = true;
        this.errorMarginFlag = true;
        this.hideRange = false;
        return value.disabled || value.isReadOnly ? '' : 'sClass';
      }

      if (value.crReading > 0 && value.crReading == value.prRead1) {
        sClass = "md-invalid";
        this.errorMarginFlag = true;
        value.bZeroConsumption = true;
        this.hideRange = false;
        return value.disabled || value.isReadOnly ? '' : 'sClass';
      }

      if (this.editingOptions.customerMeterReadingUseQuarterType == true) {
        //console.log("HHU val")
        //HHU validations

        if (this.editingOptions.billingHhuConsumptionWarningRange > 0) {
          let min;
          let max;
          let curConsumption = value.consumption;
          let curRead = value.crReading;
          let prevRead = value.prRead1;

          if (value.connType == 2) { // Bulk meter
            let subMeters = this.readings.filter((f) => f.bulkConnectionId == value.connectionId);
            let prevCons = value.previousConsumptions;
            let consumptions = [0, 0, 0, 0], avg = 0;
            let maxDiffPercent = this.editingOptions.billingHhuConsumptionWarningRange / 100.0;
            let subMetersTotalCons = 0;

            //add all 4 prec consumptions of each submeter
            subMeters.forEach((s) => {
              subMetersTotalCons = subMetersTotalCons + s.consumption;
              consumptions[0] = consumptions[0] + s.prCons1;
              consumptions[1] = consumptions[1] + s.prCons2;
              consumptions[2] = consumptions[2] + s.prCons3;
              consumptions[3] = consumptions[3] + s.prCons4;
            })

            //find the diference between added submeter consumptions and the bulk meter
            for (let i = 0; i < 4; i++) {
              avg = avg + Math.abs(consumptions[i] - prevCons[i]);
            }

            //average of the difference
            avg = avg / 4;

            let subMetersCons = 0;
            subMeters.forEach(r => {
              if (r.consumption != null && r.consumption != '')
                subMetersCons = subMetersCons + r.consumption;
            });

            value.differenceWithSubmeters = Math.abs(subMetersCons - value.consumption);
            value.bulkAverageConsumptionDiffMin = parseInt(((1 - maxDiffPercent) * avg).toString(), 10);
            value.bulkAverageConsumptionDiffMax = parseInt(((1 + maxDiffPercent) * avg).toString(), 10);

            min = value.bulkAverageConsumptionDiffMin; //if 0 dismiss
            max = value.bulkAverageConsumptionDiffMax;
          }
          else {
            min = value.similarPeriodConsumptionMin;
            max = value.similarPeriodConsumptionMax;
          }

          //console.log("value.bulkAverageConsumptionDiffMin", value.bulkAverageConsumptionDiffMin);
          //console.log("value.bulkAverageConsumptionDiffMax ", value.bulkAverageConsumptionDiffMax);
          //console.log("min", min);
          //console.log("max", max);
          //console.log("curConsumption", curConsumption);
          //console.log("curRead", curRead);
          //console.log("prevRead", prevRead);
          //console.log("value.prAvrCns", value.prAvrCns);
          //console.log("value.prCons1", value.prCons1);
          //console.log("value.prCons2", value.prCons2);
          //console.log("value.prCons3", value.prCons3);
          //console.log("value.prCons4", value.prCons4, '====> Avg ', (value.prCons1 + value.prCons2 + value.prCons3 + value.prCons4) / 4);

          value['expectedRange'] = this.expectedRangeFunc(value);
          //Checks
          if (curConsumption != null && curConsumption != '' && curConsumption <= 0.01) {
            sClass = "md-invalid";
            this.errorMarginFlag = true;
            value.bMsgMin = true;
            this.hideRange = false;
            return value.disabled || value.isReadOnly ? '' : 'sClass';
          }

          //let  avrCons = (value.prCons1 + value.prCons2 + value.prCons3 + value.prCons4) / 4;
          //if (2 * value.consumption <= avrCons) {
          //  sClass = "md-invalid";
          //  this.errorMarginFlag = true;
          //  value.bMsgMin = true;
          //  this.hideRange = false;
          //  return value.disabled || value.isReadOnly ? '' : 'sClass';
          //}

          //if (2 * value.consumption > avrCons) {
          //  sClass = "md-invalid";
          //  this.errorMarginFlag = true;
          //  value.bMsgMax = true;
          //  this.hideRange = true;
          //  return value.disabled || value.isReadOnly ? '' : 'sClass';
          //}

          if (min && curRead > prevRead && curRead < prevRead + min && value.prAvrCns > 0.01) {
            //prev + min
            sClass = "md-invalid";
            this.errorMarginFlag = true;
            value.bMsgMin = true;
            this.hideRange = false;
            return value.disabled || value.isReadOnly ? '' : 'sClass';
          }

          if (max && curRead > prevRead + max && value.prAvrCns > 0.01) {
            // prev + max
            sClass = "md-invalid";
            this.errorMarginFlag = true;
            value.bMsgMax = true;
            this.hideRange = false;
            return value.disabled || value.isReadOnly ? '' : 'sClass';
          }

        }
      }
      else {
        //console.log("Non HHU val")
        if (value.curAvrCns == null || value.curAvrCns == '')
          value.curAvrCns = 0;
        if (value.prAvrCns == null || value.prAvrCns == '')
          value.prAvrCns = 0;

        //console.log("curAvrCns ", value.curAvrCns, " ----- prAvrCns ", value.prAvrCns)
        //console.log("lower lim", this.editingOptions.lowerConsumptionLimit, " ----- upper lim ", this.editingOptions.upperConsumptionLimit)
        //console.log("prAvrCns * lowerConsumptionLimit", value.prAvrCns * this.editingOptions.lowerConsumptionLimit)

        //validation for rest customers
        if (value.crReading < value.prRead1 && value.clockOver !== true) {
          sClass = "md-invalid";
          value.bMsgNegative = true;
          this.errorMarginFlag = true;
          return value.disabled || value.isReadOnly ? '' : 'sClass';
        }

        if (value.curAvrCns < value.prAvrCns * this.editingOptions.lowerConsumptionLimit) {
          sClass = "md-invalid";
          value.bMsgMin = true;
          this.errorMarginFlag = true;
          return value.disabled || value.isReadOnly ? '' : 'sClass';
        }

        if (value.curAvrCns >= value.prAvrCns * this.editingOptions.upperConsumptionLimit) {
          sClass = "md-invalid";
          value.bMsgMax = true;
          this.errorMarginFlag = true;
          return value.disabled || value.isReadOnly ? '' : 'sClass';
        }
      }

      this.errorMarginFlag = false;
      return value.disabled || value.isReadOnly ? '' : 'sClass';
    },
    accessCodeIdToDescription(id) {
      let temp = this.descrepancyNoAccess.filter((d) => d.id == id);

      if (temp != null && temp.length > 0) return temp[0].name;
      else return "";
    },
    getCommonData() {
      this.$store.state.readingsLocalDB
        .get(`captureReadingCommonData`)
        .then((doc) => {
          const data = doc.data;

          this.editingOptions = data.editingOptions;
          this.descrepancyNoAccess = data.descrepancyNoAccess;
          this.descrepancyMrNote = data.descrepancyMrNote;
          this.meterMake = data.meterMake;
          this.meterSize = data.meterSize;
          this.consumerType = data.consumerType;
          this.isCapturePhotoMandatory = data.isCapturePhotoMandatory === true;
        })
        .catch((err) => {
          this.$alertMsg("No data found for offline mode");
          //this.$router.push("/login");
        });
    },

    prepareReading() {
      this.seq = this.editingReading.sequence;
      this.initialFieldConStatus = this.editingReading.fieldStatus;
      this.editingHistory = this.readingsHistory.filter((a) => a.sequence == this.seq);

      for (let i = 0; i < this.editingHistory.length; i++)
        this.editingHistory[i]['id'] = i;

      this.editingReading.crDate = new Date();
      this.editingReading.bMsgInvalid = false;
      this.editingReading.bMsgNegative = false;
      this.editingReading.bMsgMax = false;
      this.editingReading.bMsgMin = false;

      this.editingReading["access"] = this.accessCodeIdToDescription(this.editingReading.accessCodeId);
      this.editingReading["mrMsg"] = this.msgCodeIdToDescription(this.editingReading.mrMsgCodeId);

      this.setConsumption(this.editingReading);
      this.submetersHaveValue();
      this.GetConnectionSpHeader();

      this.picUploaded = false;

      if (!this.showGoSearch)
        this.$setFocusToElement('currReading', false);
    },
    msgCodeIdToDescription(id) {
      let item = this.descrepancyMrNote.filter((d) => d.id == id);

      if (item != null && item.length > 0) {
        if (item[0].meterReplaced == true) {
          this.editingReading.specialCase = 'meterReplaced';
          this.estimateConsumption();
        }
        else if (item[0].estimateConsumption == true) {
          this.editingReading.specialCase = 'estimateConsumption';
          this.estimateConsumption();
        }
        else
          this.editingReading.specialCase = null;

        return item[0].name;
      }
      else
        return "";
    },
    estimateConsumption() {
      const avgCons = Math.round(this.editingReading.previousConsumptions.reduce((a, b) => (a + b)) / this.editingReading.previousConsumptions.length);
      this.editingReading.averageConsumption = avgCons >= 0 ? avgCons : 0;

      if (this.editingReading.specialCase == 'estimateConsumption') {
        let read = avgCons + this.editingReading.prRead1;

        if (read.length > this.editingReading.noDials) {
          let str = '';
          for (let i = 0; i < this.editingReading.noDials; i++) {
            str = str + '9';
          }

          this.editingReading.crReading = read - Number(str);
          this.editingReading.clockOver = true;
        }

        this.editingReading.crReading = read;
      }
    },
    setConsumption(record) {
      if (record.crReading == null || record.crReading == "" || record.prRead1 == 0) {
        record.consumption = "";
        record.curAvrCns = "";

        if (record.crReading != null && record.crReading != "" && record.crReading.toString().replace(".", "").length > record.noDials) {
          this.$alertMsg(this.$t("captureMR.InputDialError"));
          record.crReading = record.crReading.substring(0, record.noDials);
        }
      }
      else {
        if (record.crReading.length > record.noDials) {
          this.$alertMsg(this.$t("captureMR.InputDialError"));
          record.crReading = record.crReading.substring(0, record.noDials);
        }

        record.consumption = record.crReading - record.prRead1;
        if (record.clockOver) {
          let clockValue = "";
          for (let i = 0; i < record.noDials; i++)
            clockValue = clockValue + "9";

          record.consumption = record.consumption + parseInt(clockValue);
        }

        var dCurrent = moment(record.crDate);
        var dPrevious = moment(record.prDate1);

        //var iDiffDays = Math.round(moment.duration(dCurrent.diff(dPrevious)).asDays());
        var iDiffDays = dCurrent.diff(dPrevious, 'days') + 1;
        if (iDiffDays === 0)
          iDiffDays = 1;

        //console.log("idif", iDiffDays)
        record.curAvrCns = iDiffDays > 0 ? record.consumption / iDiffDays : 0;
        record["curAvrCnsDisplay"] = this.roundNumberV2(record.curAvrCns, 4);
        record["prAvrCnsDisplay"] = this.roundNumberV2(record.prAvrCns, 4);
      }
    },
    calculateConsumption(record) {
      if (record.crReading == null || record.crReading == "" || record.prRead1 == 0) {
        record.consumption = "";
        record.curAvrCns = 0;
      } else {
        record.consumption = record.crReading - record.prRead1;
        if (record.clockOver) {
          let clockValue = "";
          for (let i = 0; i < record.noDials; i++)
            clockValue = clockValue + "9";

          record.consumption = record.consumption + parseInt(clockValue);
        }

        var dCurrent = moment(record.crDate);
        var dPrevious = moment(record.prDate1);
        var iDiffDays = dCurrent.diff(dPrevious, 'days') + 1;

        //console.log("idif", iDiffDays)
        record.curAvrCns = iDiffDays > 0 ? record.consumption / iDiffDays : 0;
        record["curAvrCnsDisplay"] = this.roundNumberV2(record.curAvrCns, 4);
        record["prAvrCnsDisplay"] = this.roundNumberV2(record.prAvrCns, 4);

        //if (record.prAvrCns != null && record.prAvrCns != '' && (record.prAvrCns * 2) <= record.curAvrCns) {
        //  this.highConsumptionFlag = true;
        //}
        //else {
        //  this.highConsumptionFlag = false;
        //}
      }
    },
    roundNumberV2(value, decimals) {
      return Number(Math.round(Number(value + "e" + decimals)) + "e-" + decimals);
    },
    roundNumberV1(num, scale) {
      var arr = ("" + num).split("e");
      var sig = "";
      if (+arr[1] + scale > 0) {
        sig = "+";
      }
      var i = +arr[0] + "e" + sig + (+arr[1] + scale);
      var j = Math.round(Number(i));
      var k = +(j + "e-" + scale);
      return k;
    },
    fillDataFromProfile() {
      this.bSpotBillEnabled = this.$store.state.settings.spotBilling;
      this.filtersDataObj.spotBillEnabled = this.bSpotBillEnabled;
      this.bHasPhone = this.$store.state.userProfile.hasPhone;
      this.bIsFieldWorker = this.$store.state.userProfile.isFieldWorker;

      if (this.bSpotBillEnabled) {
        this.reports = this.$store.state.captureReadingsSpotBillReports;

        if (this.reports.length > 0) this.reportId = this.reports[0].reportId;
      } else {
        this.reports = [];
        this.reportId = -1;
      }
    },
    navigateMobile(value, numb = -1) {
      switch (value) {
        case "first":
          this.iValueEditIndex = 0;
          this.setEditingReading(this.filteredReadings[this.iValueEditIndex] != null ? this.filteredReadings[this.iValueEditIndex] : this.editingReading);
          this.checkForEditedReadings();
          break;
        case "previous":
          //console.log("prev", this.iValueEditIndex);
          if (this.iValueEditIndex - 1 >= 0) {
            this.iValueEditIndex = this.iValueEditIndex - 1;
            this.setEditingReading(this.filteredReadings[this.iValueEditIndex] != null ? this.filteredReadings[this.iValueEditIndex] : this.editingReading);
          }
          else
            this.iValueEditIndex = 0;

          this.checkForEditedReadings();
          break;
        case "next":
          //console.log("next", this.iValueEditIndex);
          if (this.iValueEditIndex + 1 <= this.filteredReadings.length) {
            this.iValueEditIndex = this.iValueEditIndex + 1;
            this.setEditingReading(this.filteredReadings[this.iValueEditIndex] != null ? this.filteredReadings[this.iValueEditIndex] : this.editingReading);
          }
          else
            this.iValueEditIndex = this.filteredReadings.length - 1;

          this.checkForEditedReadings();
          break;
        case "last":
          this.iValueEditIndex = this.filteredReadings.length - 1;
          this.setEditingReading(this.filteredReadings[this.iValueEditIndex] != null ? this.filteredReadings[this.iValueEditIndex] : this.editingReading);
          this.checkForEditedReadings();
          break;
        case "back_from_search":
          this.setEditingReading(this.filteredReadings.filter((r) => r.sequence == this.selectedReadingSeq)[0]);
          this.iValueEditIndex = this.iValueEditIndexSaved;
          this.iValueEditIndexSaved = -1;
          this.selectedReadingSeq = null;
          break;
        case "go_to_reading":
          if (numb < 0)
            return;

          this.setEditingReading(this.filteredReadings.filter((r) => r.numbering == numb)[0]);
          this.iValueEditIndex = numb;
          this.iValueEditIndexSaved = -1;
          break;
        case "go_search":
          this.iValueEditIndex = numb;
          this.setEditingReading(this.filteredReadings.filter((r) => r.numbering == numb)[0]);
          break;
      }

      this.prepareReading();
      this.$root.$emit("update_selected_marker");
    },

    ///////////Search//////////////////////
    openSearch(saveSelection) {
      if (saveSelection && this.selectedReadingSeq == null) {
        this.selectedReadingSeq = this.editingReading.sequence;
        this.iValueEditIndexSaved = this.iValueEditIndex;
      }

      this.advancedSearchDialog = true;
    },
    flashBackground() {
      if (document.getElementById("edit_readings_card") == null || document.getElementById("edit_readings_card").style == null)
        return;

      let s = document.getElementById("edit_readings_card").style;
      let loops = 100;

      let timer = setInterval(function () {
        s.backgroundColor = "rgb(" + loops + "," + loops + "," + loops + ",1)";

        loops += 10;
        if (loops > 255) {
          s.backgroundColor = "#FCFFFF";
          clearInterval(timer);
        }
      }, 40);
    },
    exitGoSearch(loadResult = false) {
      if (loadResult) {
        this.goSearchEnabled = true;
        this.showGoSearch = false;
      }
      else {
        this.goSearchEnabled = false;
        this.goSearch = '';
        this.showGoSearch = false;

        this.navigateMobile("back_from_search");
      }
    },
    goSearchNavigate(index) {
      this.navigateMobile('go_search', index);
    },
    openGoSearch() {
      this.selectedReadingSeq = this.editingReading.sequence;
      this.goSearch = '';
      this.showGoSearch = true;
      this.iValueEditIndexSaved = this.iValueEditIndex;
    },
    clearAdvancedSearchResults(resetSearch = false) {
      //reset filters and show all readings so trimming or saved that changed status doesn't throw errors
      this.filtersDataObj.trim.readUnread = "0";
      this.filtersDataObj.trim.withNote = false;
      this.filtersDataObj.trim.withAccess = false;
      this.filtersDataObj.trim.disconnected = true;
      this.filtersDataObj.trim.discrepancy = false;
      this.$localStorage.set('_captureMeterReadingFilters', JSON.stringify(this.filtersDataObj.trim));

      this.filteredReadings = [...this.readings];

      this.$oldAlertMsg(this.$t('captureMR.filterReadingsAll'), 1);

      if (resetSearch) {
        this.$root.$emit('reset_advance_search');
      }

      this.searchEnabled = false;
      this.advancedSearchDialog = false;
      this.goSearchEnabled = false;
      this.goSearch = '';
      this.showGoSearch = false;

      this.navigateMobile("back_from_search");
    },
    //.................................................................
    //SMS
    //.................................................................
    sendSpotBillSms() {
      var parameter = {
        BookId: this.editingReading.bookId,
        WalkId: this.editingReading.walkId,
        Sequence: this.editingReading.sequence,
      };

      axios
        .post("/CaptureMeterReading/SendSpotBillSms", parameter)
        .then((response) => {
          if (response.status == 200) {
            this.$oldAlertMsg(this.$t("messages.SpotBillSmsSuccess"), 2);
            this.readingActionsDialog = false;
          } else this.$alertMsg(response.data, 4);
        })
        .catch((e) => {
          this.$alertMsg(e.message, 4);
        });
    },
    sendSmsReading() {
      var parameter = {
        BookId: this.editingReading.bookId,
        WalkId: this.editingReading.walkId,
        Sequence: this.editingReading.sequence,
      };

      axios.post("/CaptureMeterReading/SendReadingSms", parameter)
        .then((response) => {
          //console.log("resp", response)
          if (response.status == 200) {
            this.$oldAlertMsg(this.$t("messages.ReadingSmsSuccess"), 2);
            this.readingActionsDialog = false;
          } else this.$alertMsg(response.data, 4);
        })
        .catch((e) => {
          this.$alertMsg(e.message, 4);
        });
    },
    adHocSmsDialogOpen() {
      this.readingActionsDialog = false;
      this.showSendSmsDialog = true;
    },
    closeShowSendSmsDialog() {
      this.showSendSmsDialog = false;
    },
    async saveSmsRequests(item) {
      item['isSync'] = false;

      await this.$store.state.readingsLocalDB
        .get(`readingsSmsRequestsSavedOffline`)
        .then((doc) => {
          const smsArr = doc.requests;
          smsArr.push(item);
          //console.log("requests", smsArr);

          this.$store.state.readingsLocalDB.put({
            _id: doc._id,
            _rev: doc._rev,
            requests: smsArr,
            meterRef: this.editingReading.meterRef,
            address: this.editingReading.address
          });

          this.$oldAlertMsg(this.$t("messages.ReadingSmsSuccess"), 2);
        })
        .catch((err) => {
          if (err.status == 404) {
            console.log("err", err)
            this.$store.state.readingsLocalDB.put({
              _id: `readingsSmsRequestsSavedOffline`,
              requests: [item],
            });
            this.$oldAlertMsg(this.$t("messages.ReadingSmsSuccess"), 2);
          }
        });

      if (this.onLine)
        this.saveOfflineReadings();
    },
    openActionMenu() {
      if (this.onLine)
        this.readingActionsDialog = true
      else
        this.adHocSmsDialogOpen();
    },

    async createSpotBillReport(printReport = false) {
      var parameter = {
        BookId: this.editingReading.bookId,
        WalkId: this.editingReading.walkId,
        Sequence: this.editingReading.sequence,
        ReportId: this.reportId,
        EscPosData: true,
      };

      if (printReport == false) {
        let printReceipt = await this.printSpotBill(parameter);

        if (printReceipt == true) {
          this.enablePrintReport = false;
          return;
        } else this.enablePrintReport = true;
      }

      axios.post("/CaptureMeterReading/CreateSpotBillReport", parameter)
        .then((response) => {
          if (response.data.data.status == 0) {
            this.$oldAlertMsg(this.$t("messages.CreateSpotBillReportSuccess"), 2);
            var url = response.data.url;
            window.open(url, "_blank");
          } else this.$alertMsg(response.data.data.text, 4);
        })
        .catch((e) => {
          this.$alertMsg(e.message, 4);
        });
    },
    async issueSpotBilling(reading, haveGeolocation) {
      if (this.editingReading.statementNo && this.editingOptions.spotBillAllowToReIssue) {
        if (await !this.updateCheckReadingFlag())
          return;
      }

      if ((!reading.crReading || reading.crReading === null || reading.crReading === "" ||
        reading.crReading < 0 || reading.crReading > Math.pow(10, reading.noDials) - 1) &&
        reading.accessCodeId == 0) {
        this.$alertMsg(this.$t("captureMR.CurReadingError"), 4);
        return;
      }

      if (moment(reading.crDate).isAfter(new Date())) {
        this.$alertMsg(this.$t("captureMR.currDateError"), 4);
        return;
      }

      var parameter = {
        BookId: reading.bookId,
        WalkId: reading.walkId,
        Sequence: reading.sequence,

        CrReading: reading.crReading,
        ClockOver: reading.clockOver,
        CrDateTime: moment(reading.crDate).format("YYYY-MM-DDTHH:mm:ss"),

        AccessCodeId: reading.accessCodeId,
        MrMsgCodeId: reading.mrMsgCodeId,
        SerialNo: reading.serialNo,
        MeterMakeId: reading.meterMakeId,
        MeterSizeId: reading.meterSizeId,
        NoDials: reading.noDials,
        CellTelNo: reading.cellTelNo,
        ConsumerTypeId: reading.consumerTypeId,
        Comment: reading.comment,

        CoordLat: reading.connectionCoordX,
        CoordLong: reading.connectionCoordY,
        CoordAccuracy: 0,
      };

      if (reading.specialCase) {
        parameter['Consumption'] = reading.averageConsumption;
      }

      if (this.geoLocation != null) {
        parameter.CoordLat = this.geoLocation.latitude;
        parameter.CoordLong = this.geoLocation.longitude;
        parameter.CoordAccuracy = this.geoLocation.accuracy;
      }

      this.issueAfterUpdate = true;

      if (!haveGeolocation)
        this.$oldAlertMsg(this.$t("messages.noGeolocationCaptured"), 3);

      axios.post("/CaptureMeterReading/UpdateReadingDetails", parameter)
        .then((response) => {
          if (response.status == 200) {
            if (response.data.data != null && response.data.data.status != 0) {
              this.$alertMsg(response.data.data.text, 4);
              return;
            }
            this.editingReading.isEdited = false;
            //this.$alertMsg(this.$t('messages.ReadingUpdatedSuccess'), 2);
            this.hasReadingUpdated = true;
            this.setEditingReading(response.data.item, false);
            let index = this.readings.findIndex(
              (f) => f.connectionId == response.data.item.connectionId
            );
            this.readings[index] = response.data.item;

            this.editingReading.status = response.data.item.status;

            if (this.highConsumptionFlag == true)
              this.showSmsWindowChoices = true;

            if (this.updateReadingAlert(response.data, parameter))
              this.issueSpotBilling2();
          } else this.$alertMsg(response.data.data.text, 4);
        })
        .catch((e) => {
          this.$alertMsg(e.message, 4);
        });
    },
    issueSpotBilling2() {
      var parameterAux = {
        BookId: this.editingReading.bookId,
        WalkId: this.editingReading.walkId,
        Sequence: this.editingReading.sequence,
        EscPosData: true,
      };

      let loaderAux11 = this.$loading.show({ color: "#23348d", loader: "dots", width: 256, height: 256, backgroundColor: "#ffffff", opacity: 0.5, });
      axios
        .post("/CaptureMeterReading/IssueSpotBill", parameterAux)
        .then((response) => {
          if (response.data.data.status == 0) {
            this.$oldAlertMsg(this.$t('messages.IssueSpotBillSuccess'), 2);
            var newReading = response.data.item;
            this.editingReading.crReading = newReading.crReading;
            this.editingReading.crTime = newReading.crTime;
            this.editingReading.statementNo = newReading.statementNo;
            this.editingReading.status = newReading.status;
            this.editingReading.statusText =
              newReading.status === 1 ? "Unread"
                : newReading.status === 2 ? "Read"
                  : newReading.status === 3 ? "Completed"
                    : "Unknown";
            this.createSpotBillReport();
          } else this.$alertMsg(response.data.data.text, 4);

          loaderAux11.hide();
        })
        .catch((e) => {
          loaderAux11.hide();
          this.$alertMsg(e.message, 4);
        })
        .finally(() => (this.requestParameter = {}));
    },
    updateCheckReadingFlag() {
      var parameter = {
        BookId: this.editingReading.bookId,
        WalkId: this.editingReading.walkId,
        Sequence: this.editingReading.sequence,
        CheckReading: true,
      };

      return axios.post("/CaptureMeterReading/UpdateCheckReadingFlag", parameter)
        .then((response) => {
          if (response.status != 200) {
            this.$alertMsg(response.data.data.text, 4);
            return false;
          };
          return true;
        })
        .catch((e) => {
          this.$alertMsg(e.message, 4);
          return false;
        });
    },
    printSpotBill(parameter) {
      let loaderAux111 = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      return axios
        .post("/CaptureMeterReading/CreateSpotBillEscPosReceipt ", parameter)
        .then((response) => {
          if (response.status == 200) {
            this.printReceipt(response.data.escPosData);
            loaderAux111.hide();
            this.requestParameter = {};
            return true;
          } else {
            this.$alertMsg(response.data.Message, 4);
            loaderAux111.hide();
            this.requestParameter = {};
            return false;
          }
        })
        .catch((e) => {
          loaderAux111.hide();
          this.$alertMsg(e.message, 4);
          this.requestParameter = {};
          loaderAux111.hide();
          return false;
        });
    },
    printReceipt(printStr) {
      var S = "#Intent;scheme=rawbt;";
      var P = "package=ru.a402d.rawbtprinter;end;";
      var textEncoded = "base64," + printStr;
      window.location.href = "intent:" + textEncoded + S + P;
      //printing is done with 3d party app on android
      // https://rawbt.ru/start.html
    },
    fillGeoLocation(data, callBack = null, next = false) {
      var geoOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      var geo = navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.geoLocation = { latitude: pos.coords.latitude, longitude: pos.coords.longitude, accuracy: pos.coords.accuracy };
          this[callBack](data, true, next);
        },
        (err) => {
          this.geoLocation = null;
          //this.$alertMsg(err.message, 4);
          this.geoLocation = { latitude: 0, longitude: 0, accuracy: 0 };
          this[callBack](data, true, next);
        },
        geoOptions
      );
    },

    //============================================================
    //Save Readings
    //============================================================
    async saveReadingLocally(reading = null, readings = []) {
      if (reading) {
        this.readings.forEach(r => {
          if (r.meterRef == reading.meterRef) {
            r = { ...reading };
          }
        })
      }

      let r = null;
      await this.$store.state.readingsLocalDB
        .get(`${this.book}_${this.walk}`)
        .then((doc) => {
          if (readings.length > 0) {
            r = [];
            readings.forEach(read => {
              r.push(doc.readings.filter((a) => a.connectionId == read.connectionId)[0]);
              this.saveReadingLocally_helper(r[r.length - 1], read);
            });
          }
          else {
            r = doc.readings.filter((a) => a.connectionId == reading.connectionId)[0];
            this.saveReadingLocally_helper(r, reading);
          }

          this.$store.state.readingsLocalDB.put({
            _id: doc._id,
            _rev: doc._rev,
            bookId: this.book,
            walkId: this.walk,
            readings: doc.readings,
            readingsHistory: doc.readingsHistory,
            connectionsSpHeaders: doc.connectionSpHeaders,
          });

          this.hasReadingUpdated = true;
          this.initialFieldConStatus = this.editingReading.fieldStatus;
        });

      return r;
    },
    saveReadingLocally_helper(r, reading) {
      r.offlineUpdated = 1;
      r.accessCodeId = reading.accessCodeId,
        r.mrMsgCodeId = reading.mrMsgCodeId
      r.crReading = reading.crReading
      r.clockOver = reading.clockOver;
      r.crDate = moment(reading.crDate).format("YYYY-MM-DDTHH:mm:ss");
      r.consumerTypeId = reading.consumerTypeId;
      r.comment = reading.comment;
      r.connectionCoordX = this.geoLocation != null ? this.geoLocation.latitude : '';
      r.connectionCoordY = this.geoLocation != null ? this.geoLocation.longitude : '';
      r.accuracy = this.geoLocation != null ? this.geoLocation.accuracy : '';
      r.connectionGpsX = reading.connectionGpsX;
      r.connectionGpsY = reading.connectionGpsY;
      r.similarPeriodConsumptionMax = reading.similarPeriodConsumptionMax;
      r.similarPeriodConsumptionMin = reading.similarPeriodConsumptionMin;
      r.averageConsumption = reading.averageConsumption;
      r.specialCase = reading.specialCase;
      r.fieldStatus = reading.fieldStatus ?? 0;
    },
    async checkDifOfBulkAndSubmeters(bulk) {
      if (bulk && bulk.differenceWithSubmeters > 0) {
        this.$alertMsg(`${this.$t("captureMR.SubconnectionsConsDifference")} ${this.$t("captureMR.By")} ${bulk.differenceWithSubmeters}`, 3);
        await new Promise((resolve) => setTimeout(resolve, 2000));
      }
    },
    checkForEditedReadings(showNotification = true) {
      if (this.readings.filter(r => r.isEdited == true && this.editingReading.meterRef != r.meterRef).length > 0) {
        if (showNotification)
          this.$alertMsg(this.$t("captureMR.unsavedReadingsWarning") + this.$t("captureMR.unsavedReadingsWarning1"), 1);

        return true;
      }
      return false;
    },
    async updateReadingDetails(reading, haveGeolocation, next) {
      this.checkForEditedReadings();

      if (this.editingReading.statementNo && this.editingOptions.spotBillAllowToReIssue) {
        this.updateCheckReadingFlag();
      }

      this.isButtonDisabled = true;
      if (((!reading.crReading || reading.crReading === null || reading.crReading === "" ||
        reading.crReading < 0 || reading.crReading > Math.pow(10, reading.noDials) - 1) && reading.accessCodeId == 0) && !this.disconnectedMeter) {
        return;
      }

      //bulk meter warning about non read submeters
      if (reading.connType == 2 && this.editingOptions.customerMeterReadingUseQuarterType == true) {
        //find sub meters
        let reads = this.readings.filter((f) => f.bulkConnectionId == this.editingReading.connectionId);
        let flag = this.submetersHaveValue(reads);

        if (flag == false) {
          this.$alertMsg(this.$t("captureMR.SubconnectionsNotRead"), 3);
          await new Promise((resolve) => setTimeout(resolve, 2000));
        }
        else {
          await this.checkDifOfBulkAndSubmeters(this.editingReading);
        }
      }

      if (moment(reading.crDate).isAfter(new Date())) {
        this.$alertMsg(this.$t("captureMR.currDateError"), 4);
        return;
      }

      let r = await this.saveReadingLocally(reading);

      if (!haveGeolocation)
        this.$oldAlertMsg(this.$t("messages.noGeolocationCaptured"), 3);

      await this.$store.state.readingsLocalDB
        .get(`readingsSavedOffline`)
        .then((doc) => {
          const rLen = doc.readings.filter((a) => a.bookId == this.book && a.walkId == this.walk && a.seq == reading.sequence).length;
          let readArr = doc.readings;

          if (rLen == 0) {
            //console.log("readingsSavedOffline rLenth == 0")
            readArr.push({
              bookId: this.book,
              walkId: this.walk,
              seq: reading.sequence,
              reading: r,
              isSync: false,
            });
          }
          else {
            let indx = doc.readings.findIndex((a) => a.bookId == this.book && a.walkId == this.walk && a.seq == reading.sequence);
            readArr[indx].reading = r;
          }

          this.$store.state.readingsLocalDB.put({
            _id: doc._id,
            _rev: doc._rev,
            readings: readArr,
          });
          this.$oldAlertMsg(this.$t("messages.ReadingUpdatedSuccess"), 2);
        })
        .catch((err) => {
          if (err.status == 404) {
            this.$store.state.readingsLocalDB.put({
              _id: `readingsSavedOffline`,
              readings: [
                {
                  bookId: this.book,
                  walkId: this.walk,
                  seq: reading.sequence,
                  reading: r,
                  isSync: false,
                },
              ],
            });
            this.$oldAlertMsg(this.$t("messages.ReadingUpdatedSuccess"), 2);
          }
        })
        .finally(() => {
          this.isButtonDisabled = false;
          this.editingReading.isEdited = false;
        });

      this.saveOfflineReadings();

      if (next && this.searchEnabled != true && !this.cameFromSearch && !this.isButtonDisabled) {
        this.navigateMobile('next')
      }
    },
    submetersHaveValue(reads) {
      this.editingReading.bSubmetersDoesNotHaveValue = false;
      if (reads == null || reads.length == 0) {
        reads = this.readings.filter((f) => f.bulkConnectionId == this.editingReading.connectionId);

        if (reads == null || reads.length == 0)
          return false;
      }

      //check readings have reading value 
      var flag;
      if (reads.length > 0) {
        reads.every((r) => {
          if (r.crReading == null || r.crReading <= 0 && !r.disabled && !r.isReadOnly) {
            flag = true;
            this.editingReading.bSubmetersDoesNotHaveValue = true;
            this.errorMarginFlag = true;
            return false;
          }
        });
      }
      return !flag;
    },
    paragraphedDialogText(str) {
      return ` <p>${str}</p>`
    },
    updateReadingAlert(item, parameter) {
      if (item.alertId == 2) {
        this.alertWarningDialogTitle = this.$t("problemLog.Warning");
        this.alertWarningDialogContent = item.alertMessage + '#' + this.paragraphedDialogText(item.meterRef) + this.paragraphedDialogText(item.propertyAddress);
        this.alertWarningDialog = true;
        return true;
      } else if (item.alertId == 1) {
        this.requestParameter = parameter;
        this.alertErrorDialogContent = item.alertMessage;
        this.alertErrorDialog = true;
        return false;
      } else return true;
    },
    togglePrevReadingsTableVisibility() {
      this.prevReadingsTableVisibility = !this.prevReadingsTableVisibility;
    },
    writePrevReadingsTableVisibility(item) {
      this.$localStorage.set("_prevReadingsTableVisibility", item);
    },
    showChart() {
      let obj = { description: "" };
      let arr = [];
      let arr1 = [];
      let iConsumptionSum = 0;
      let iConsumptionCount = 0;

      this.editingHistory.forEach((item) => {
        obj[item.period] = item.consumption;
        arr.unshift({ valueField: item.period, name: item.period });
        arr1.unshift({ argumentField: item.period, value: item.consumption });
        iConsumptionSum = iConsumptionSum + item.consumption;
        iConsumptionCount++;
      });

      let iAvg =
        iConsumptionCount > 0 ? iConsumptionSum / iConsumptionCount : 0;
      let title = this.editingReading.tenantName;
      let subtitle = "Avg: " + iAvg.toFixed(2).toString();

      this.dxBarChartData = [obj];
      this.dxBarChartOptions = {
        title: title,
        subtitle: subtitle,
        dataOptions: arr,
      };

      this.dxLineChartData = arr1;
      this.dxLineChartOptions = [
        { value: "value", name: this.$t("captureMR.ColConsumption") },
      ];

      this.bShowGraph = true;
    },

    //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    //Filter readings
    filterReadings(reads) {
      this.filteredReadings = [...reads];

      if (this.filteredReadings.length > 0) {
        if (this.seq == -1) {
          this.iValueEditIndex = 0;
          this.seq = this.filteredReadings[0].sequence;
          this.setEditingReading(this.filteredReadings[0]);
          this.editingHistory = this.readingsHistory.filter((a) => a.sequence == this.seq);
        }
        else {
          if (this.filteredReadings.filter((a) => a.sequence == this.seq).length > 0) {
            for (let i = 0; i < this.filteredReadings.length; i++) {
              if (this.filteredReadings[i].sequence == this.seq) {
                this.iValueEditIndex = i;
                break;
              }
            }

            this.setEditingReading(this.filteredReadings.filter((a) => a.sequence == this.seq)[0]);
            this.editingHistory = this.readingsHistory.filter((a) => a.sequence == this.seq);
          } else {
            this.iValueEditIndex = 0;
            this.seq = this.filteredReadings[0].sequence;
            this.setEditingReading(this.filteredReadings[0]);
            this.editingHistory = this.readingsHistory.filter((a) => a.sequence == this.seq);
          }
        }

        this.prepareReading();
        this.readingsReady = true;
      }
    },
    editSearchReadingMobile(item, obj) {
      if (!item) return;

      this.iValueEditIndexSaved = this.iValueEditIndex;
      this.filtersDataObj.trim = { ...obj.trim };
      //this.filteredReadings = [...obj.filteredReadings];
      //this.filtersDataObj.filtersDataObj = [...obj.filteredReadings];
      if (this.loadSearchList !== true) {
        this.setEditingReading(item);
        this.searchEnabled = true;
        this.prepareReading();
      }

      this.editingReading.crDate = new Date();
      this.advancedSearchDialog = false;
    },
    GetConnectionSpHeader() {
      this.infoLine1 = "";

      if (!this.onLine) {
        return;
      }

      axios
        .get("/CaptureMeterReading/GetConnectionSpHeader?connectionId=" + this.editingReading.connectionId)
        .then((response) => {
          this.infoLine1 = response.data;
        })
        .catch((e) => {
          return;
        });
    },

    //=============================================================
    //Camera
    openCamera(closeAfterSave = false) {
      this.closeCamDialogAfterSave = closeAfterSave;
      this.bShowCamera = true;
    },
    closeCameraComponent() {
      this.bShowCamera = false;
      this.$setFocusToElement('currReading', true, 500);
    },
    downloadPhoto(id) {
      let loader = this.$loading.show({ color: "#23348d", loader: "dots", width: 256, height: 256, backgroundColor: "#ffffff", opacity: 0.5, });
      axios.post("/CaptureMeterReading/DownloadPhoto", { Value: id }, { responseType: "blob" })
        .then(files.getFile)
        .then((link) => {
          link.click();
        })
        .then((response) => {
          loader.hide();
        })
        .catch((err) => {
          loader.hide();
          console.log(err);
        });
    },
    async processPhotos(data) {
      let img = data.image;

      if (data.close) this.closeCameraComponent();

      if (!img) return;

      if (this.editingReading.meterId <= 0) {
        this.$alertMsg(this.$t("messages.MeterIdNotSetForReading"), 4);
        return;
      }


      if (this.onLine) {
        var formData = new FormData();
        formData.append("meterId", this.editingReading.meterId.toString());
        formData.append("cycleId", this.cycleId.toString());
        formData.append("connectionId", this.editingReading.connectionId.toString());
        formData.append("photoBase64", img);

        return axios.post("/CaptureMeterReading/ProcessPhoto", formData, { headers: { "Content-Type": "multipart/form-data" }, })
          .then((response) => {
            this.$root.$emit("camera_photos_updated");
            this.$oldAlertMsg(this.$t("messages.PhotoSavedSuccess"), 2);
            this.getPhotos();
            this.picUploaded = true;
          })
          .catch((e) => {
            this.picUploaded = false;
            return false;
          });
      }
      else {
        this.$store.state.readingsLocalDB.get(`readingsPhotosSavedOffline`)
          .then((doc) => {
            return this.$store.state.readingsLocalDB.put({
              _id: 'readingsPhotosSavedOffline',
              _rev: doc._rev,
              photos: [...doc.photos,
              {
                meterId: this.editingReading.meterId.toString(),
                cycleId: this.cycleId.toString(),
                connectionId: this.editingReading.connectionId.toString(),
                photoBase64: img,
                isSync: false,
                meterRef: this.editingReading.meterRef,
                address: this.editingReading.propertyAddress
              }]
            });
          })
          .catch((err) => {
            if (err.status == 404) {
              this.$store.state.readingsLocalDB.put({
                _id: `readingsPhotosSavedOffline`,
                photos: [
                  {
                    meterId: this.editingReading.meterId.toString(),
                    cycleId: this.cycleId.toString(),
                    connectionId: this.editingReading.connectionId.toString(),
                    photoBase64: img,
                    isSync: false,
                  },
                ],
              });
            }
          })
          .finally(() => this.picUploaded = true);
      }
    },
    async getPhotos() {
      if (this.editingReading.meterId <= 0) return;

      var parameter = {
        MeterId: this.editingReading.meterId,
        CycleId: this.cycleId,
        ConnectionId: this.editingReading.connectionId,
      };

      this.photos.length = 0;
      return await axios.post("/CaptureMeterReading/GetPhotos", parameter)
        .then((response) => {
          if (response.data.data.status == 0) {
            this.photos = response.data.items;
            return response.data.items;
          }
          else {
            this.closeWithMessage(this.$t("messages.CannotGetPhotosFromServer"));
            return null;
          }
        })
        .catch((e) => {
          return null;
        });
    },
    async viewPhoto(id) {
      let loader = this.$loading.show({ color: "#23348d", loader: "dots", width: 256, height: 256, backgroundColor: "#ffffff", opacity: 0.5, });
      return await axios.post("/CaptureMeterReading/ViewPhoto", { Value: id })
        .then((response) => {
          if (response.data.data.status == 0) {
            loader.hide();
            return response.data.img;
          } else {
            this.$alertMsg(response.data.data.text, 4);
            loader.hide();
            return null;
          }
        })
        .catch((e) => {
          loader.hide();
          this.$alertMsg(e.message, 4);
          return null;
        });
    },
    //=============================================================
    showHelp(type) {
      switch (type) {
        case "consType":
          this.$oldAlertMsg(
            this.$t("captureMR.ColumnConsumerType") +
            ": " +
            this.editingReading.consumerType,
            1
          );
          break;
        case "cons":
          this.$oldAlertMsg(
            this.$t("captureMR.CurrentConsumption") +
            ": " +
            this.editingReading.consumption,
            1
          );
          break;
        case "avgCons":
          this.$oldAlertMsg(
            this.$t("captureMR.avgCons") +
            ": " +
            this.editingReading.curAvrCnsDisplay,
            1
          );
          break;
        case "prevCons":
          this.$oldAlertMsg(
            this.$t("captureMR.PrevConsumption") +
            ": " +
            this.editingReading.prRead1,
            1
          );
          break;
        case "prevRdg":
          this.$oldAlertMsg(
            this.$t("captureMR.PrevReading") +
            ": " +
            this.editingReading.prCons1,
            1
          );
          break;
        case "prevAvg":
          this.$oldAlertMsg(
            this.$t("captureMR.prevAvgCons") +
            ": " +
            this.editingReading.prAvrCnsDisplay,
            1
          );
          break;
      }
    },




    //===========================
    //Gesture Control
    //getTouches(evt) {
    //  return evt.touches; // browser API
    //},
    //touchMove(evt) {
    //  if (!this.xDown || !this.yDown) {
    //    return;
    //  }

    //  let xUp = evt.touches[0].clientX;
    //  let yUp = evt.touches[0].clientY;

    //  let xDiff = this.xDown - xUp;
    //  let yDiff = this.yDown - yUp;

    //  if (Math.abs(xDiff) > Math.abs(yDiff)) {
    //    /*most significant*/
    //    if (xDiff > 0) {
    //      if (this.searchEnabled != true && !this.cameFromSearch)
    //        this.navigateMobile("next");
    //    } else {
    //      if (this.searchEnabled != true && !this.cameFromSearch)
    //        this.navigateMobile("previous");
    //    }
    //  }

    //  /* reset values */
    //  this.xDown = null;
    //  this.yDown = null;
    //},
    //touchStart(evt) {
    //  const firstTouch = this.getTouches(evt)[0];
    //  this.xDown = firstTouch.clientX;
    //  this.yDown = firstTouch.clientY;
    //},
    //===========================

  },
};
